/* eslint-disable no-magic-numbers */
import { usePointToProjection } from '@/utils/map/usePointToProjection';
import Feature from 'ol/Feature';
import { Geometry } from 'ol/geom';
import VectorSource from 'ol/source/Vector';
import { useSelector } from 'react-redux';
import {
  allCommentsSelectorOfCurrentMap,
  commentSelector,
} from '@/redux/comment/comment.selectors';
import { getCommentsFeatures } from '@/components/Map/MapViewer/utils/config/commentsLayer/getCommentsFeatures';
import { useMemo, useEffect } from 'react';

/**
 * Builds the shared {@link VectorSource} with comment pin features derived from
 * the Redux store. Map-independent; wrap it with `createCommentsLayer`.
 */
export const useOlMapCommentsSource = (): VectorSource<Feature<Geometry>> => {
  const pointToProjection = usePointToProjection();
  const comments = useSelector(allCommentsSelectorOfCurrentMap);
  const isVisible = useSelector(commentSelector).isOpen;

  const elementsFeatures = useMemo(
    () =>
      [
        getCommentsFeatures(isVisible ? comments : [], {
          pointToProjection,
        }),
      ].flat(),
    [comments, pointToProjection, isVisible],
  );

  const vectorSource = useMemo(() => new VectorSource<Feature<Geometry>>(), []);

  useEffect(() => {
    vectorSource.clear();
    vectorSource.addFeatures(elementsFeatures);
  }, [elementsFeatures, vectorSource]);

  return vectorSource;
};
